// CallScreenAfterCall.js
import { Badge, Button, message, Typography } from "antd";
import { AudioOutlined, AudioMutedOutlined, PhoneOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import {
  RoomAudioRenderer,
  useLocalParticipant,
  useMaybeRoomContext,
  useRoomContext,
} from "@livekit/components-react";

import "./CallScreenAfterCall.css";

const { Text } = Typography;

export default function CallScreenAfterCall({ endCall , setText,}) {
  const { localParticipant, isMicrophoneEnabled } = useLocalParticipant();
  const room = useMaybeRoomContext();
  const rom = useRoomContext();

  const [callDuration, setCallDuration] = useState(0);
  const [isAgentSpeaking, setIsAgentSpeaking] = useState(false);
  const [hasSpokenOnce, setHasSpokenOnce] = useState(false);
  const isUserSpeaking = localParticipant?.isSpeaking ?? false;

  useEffect(() => {
    const onRoomDisconnect = () => {
      message.success("Call ended");
      endCall();
    };

    rom.on("disconnected", onRoomDisconnect);

    return () => {
      rom.off("disconnected", onRoomDisconnect);
    };
  }, [rom, endCall]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

const [oldText, setOldText] = useState("");

useEffect(() => {
  if (!room) return;

  const handleBotSpeaking = (segments, participant) => {
    if (participant?.identity?.startsWith("agent")) {
      segments.forEach((s) => {
        const newText = s.text;


        console.log("oldText:", oldText);
        console.log("newText:", newText);

        // Only get the new portion
        let lastChar = newText.charAt(newText.length - 1);

        if (lastChar === "." || lastChar === "?") {
          let added = "";
          if (newText.startsWith(oldText)) {
            added = newText.slice(oldText.length);
          } else {
            const index = newText.indexOf(oldText);
            added =
              index !== -1
                ? newText.slice(index + oldText.length)
                : newText;
          }

          console.log("Added text:", added);
           if (added.trim()) {
            setText(added);
          }
          setOldText(newText);
        }
      });
    }

    const botSpeaking = segments.some(() =>
      participant?.identity?.startsWith("agent")
    );

    setIsAgentSpeaking(botSpeaking);
    setHasSpokenOnce(true);

    if (botSpeaking) {
      setTimeout(() => {
        setIsAgentSpeaking(false);
      }, 550);
    }
  };

  room.on("transcriptionReceived", handleBotSpeaking);
  return () => room.off("transcriptionReceived", handleBotSpeaking);
}, [room, oldText]);


  useEffect(() => {
    const timer = setInterval(() => {
      setCallDuration((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  if (!hasSpokenOnce) {
    return (
      <div className="connecting-container">
        <div className="spinner"></div>
        <span className="connecting-text">Connecting...</span>
      </div>
    );
  }

  return (
    <div className="callscreen-container">
      {/* Call Timer */}
      <div className="call-timer">
        <Badge status="processing" />
        <Text className="call-timer-text">{formatTime(callDuration)}</Text>
      </div>

      {/* <RoomAudioRenderer /> */}

      {/* Voice Activity Indicators */}
      <div className="voice-indicators">
        {/* User Speaking Indicator */}
        <div className="voice-row">
          <Text className="voice-label">You</Text>
          <div className="voice-bars">
            {[...Array(8)].map((_, i) => (
              <div
                key={i}
                className={`bar ${isUserSpeaking ? "active" : "inactive"}`}
                style={{
                  animationDelay: `${i * 100}ms`,
                  height: isUserSpeaking ? `${8 + (i % 3) * 4}px` : "4px",
                }}
              ></div>
            ))}
          </div>
        </div>

        {/* Agent Speaking Indicator */}
        <div className="voice-row">
          <Text className="voice-label">Agent</Text>
          <div className="voice-bars">
            {[...Array(8)].map((_, i) => (
              <div
                key={i}
                className={`bar ${isAgentSpeaking ? "active-green" : "inactive"}`}
                style={{
                  animationDelay: `${i * 100}ms`,
                  height: isAgentSpeaking ? `${8 + (i % 3) * 4}px` : "4px",
                }}
              ></div>
            ))}
          </div>
        </div>
      </div>

      {/* Call Controls */}
      <div className="call-controls">
        <Button
          type={!isMicrophoneEnabled ? "primary" : "default"}
          danger={!isMicrophoneEnabled}
          onClick={() => {
            localParticipant?.setMicrophoneEnabled(!isMicrophoneEnabled);
          }}
          icon={!isMicrophoneEnabled ? <AudioMutedOutlined /> : <AudioOutlined />}
          className="control-button"
          size="small"
        >
          {!isMicrophoneEnabled ? "Unmute" : "Mute"}
        </Button>

        <Button
          type="primary"
          danger
          icon={<PhoneOutlined />}
          onClick={endCall}
          className="control-button"
          size="small"
        >
          End
        </Button>
      </div>
    </div>
  );
}
